import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 mb-25" }
const _hoisted_3 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_4 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { class: "d-flex gap-2" }
const _hoisted_6 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_7 = { class: "row mb-3" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "col-md-3" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "col-md-3" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "col-md-2" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "col-12" }
const _hoisted_17 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_18 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_19 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_20 = {
  key: 1,
  class: "text-center py-4"
}
const _hoisted_21 = { key: 2 }
const _hoisted_22 = { class: "d-md-none" }
const _hoisted_23 = { class: "card border-0 shadow-sm" }
const _hoisted_24 = { class: "card-body" }
const _hoisted_25 = { class: "d-flex justify-content-between align-items-start mb-2" }
const _hoisted_26 = { class: "fw-bold mb-0" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "text-muted small mb-1" }
const _hoisted_29 = { class: "text-muted small mb-1" }
const _hoisted_30 = { class: "text-muted small mb-2" }
const _hoisted_31 = { class: "d-flex gap-2" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "d-none d-md-block" }
const _hoisted_34 = { class: "table-responsive" }
const _hoisted_35 = { class: "table align-middle mb-0" }
const _hoisted_36 = { class: "fw-medium" }
const _hoisted_37 = { class: "badge bg-info" }
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = { class: "text-end" }
const _hoisted_40 = { class: "dropdown" }
const _hoisted_41 = { class: "dropdown-menu" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { key: 1 }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { key: 2 }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { key: 3 }
const _hoisted_49 = { key: 4 }
const _hoisted_50 = ["onClick"]
const _hoisted_51 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center mt-3"
}
const _hoisted_52 = { class: "text-muted" }
const _hoisted_53 = { class: "pagination pagination-sm mb-0" }
const _hoisted_54 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[13] || (_cache[13] = _createElementVNode("h4", { class: "fw-bold text-black mb-0" }, "Mes Dossiers", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadDossiers && _ctx.loadDossiers(...args))),
              class: "btn btn-outline-primary btn-sm"
            }, [...(_cache[11] || (_cache[11] = [
              _createElementVNode("i", { class: "flaticon-refresh me-1" }, null, -1),
              _createTextVNode(" Actualiser ", -1)
            ]))]),
            _createVNode(_component_router_link, {
              to: "/ajouter/etape-1",
              class: "btn btn-primary btn-sm"
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createElementVNode("i", { class: "flaticon-plus me-1" }, null, -1),
                _createTextVNode(" Nouveau dossier ", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[14] || (_cache[14] = _createElementVNode("label", { class: "form-label" }, "Rechercher", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.search) = $event)),
                  onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args))),
                  type: "text",
                  class: "form-control",
                  placeholder: "Référence, client, destination..."
                }, null, 544), [
                  [_vModelText, _ctx.filters.search]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[15] || (_cache[15] = _createElementVNode("label", { class: "form-label" }, "Statut", -1)),
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.filters.status,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.status) = $event)),
                  options: _ctx.statusOptions,
                  searchable: false,
                  "close-on-select": true,
                  placeholder: "Tous les statuts",
                  onChange: _ctx.applyFilters
                }, null, 8, ["modelValue", "options", "onChange"])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "form-label" }, "Date de création", -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.dateFrom) = $event)),
                  onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.applyFilters && _ctx.applyFilters(...args))),
                  type: "date",
                  class: "form-control"
                }, null, 544), [
                  [_vModelText, _ctx.filters.dateFrom]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label" }, " ", -1)),
                _createElementVNode("button", {
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args))),
                  class: "btn btn-outline-secondary w-100"
                }, [...(_cache[17] || (_cache[17] = [
                  _createElementVNode("i", { class: "flaticon-close me-1" }, null, -1),
                  _createTextVNode(" Effacer ", -1)
                ]))])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[19] || (_cache[19] = [
                _createElementVNode("div", {
                  class: "spinner-border text-primary",
                  role: "status"
                }, [
                  _createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
                ], -1)
              ]))]))
            : (_ctx.filteredDossiers.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [...(_cache[20] || (_cache[20] = [
                  _createElementVNode("i", {
                    class: "flaticon-folder-open text-muted",
                    style: {"font-size":"48px"}
                  }, null, -1),
                  _createElementVNode("p", { class: "text-muted mt-2" }, "Aucun dossier trouvé", -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedDossiers, (dossier) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: dossier.id,
                        class: "dossier-card mb-3"
                      }, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("h6", _hoisted_26, _toDisplayString(dossier.refbesc), 1),
                              _createElementVNode("span", {
                                innerHTML: _ctx.getStatusBadge(dossier.status)
                              }, null, 8, _hoisted_27)
                            ]),
                            _createElementVNode("p", _hoisted_28, [
                              _cache[21] || (_cache[21] = _createElementVNode("i", { class: "flaticon-user me-1" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(dossier.client), 1)
                            ]),
                            _createElementVNode("p", _hoisted_29, [
                              _cache[22] || (_cache[22] = _createElementVNode("i", { class: "flaticon-location me-1" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(dossier.destination), 1)
                            ]),
                            _createElementVNode("p", _hoisted_30, [
                              _cache[23] || (_cache[23] = _createElementVNode("i", { class: "flaticon-calendar me-1" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.format_date(dossier.created_at)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_component_router_link, {
                                to: { name: 'ViewBesc', params: { id: dossier.id } },
                                class: "btn btn-primary btn-sm flex-fill"
                              }, {
                                default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                  _createElementVNode("i", { class: "flaticon-eye me-1" }, null, -1),
                                  _createTextVNode(" Voir ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["to"]),
                              (dossier.status === 'BROUILLON')
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.editDossier(dossier.id)),
                                    class: "btn btn-outline-primary btn-sm flex-fill"
                                  }, [...(_cache[25] || (_cache[25] = [
                                    _createElementVNode("i", { class: "flaticon-edit me-1" }, null, -1),
                                    _createTextVNode(" Modifier ", -1)
                                  ]))], 8, _hoisted_32))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("table", _hoisted_35, [
                        _cache[33] || (_cache[33] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, "Référence BESC"),
                            _createElementVNode("th", null, "Client"),
                            _createElementVNode("th", null, "Destination"),
                            _createElementVNode("th", null, "Type de transport"),
                            _createElementVNode("th", null, "Statut"),
                            _createElementVNode("th", null, "Date création"),
                            _createElementVNode("th", null, "Dernière modification"),
                            _createElementVNode("th", { class: "text-end" }, "Actions")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedDossiers, (dossier) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: dossier.id
                            }, [
                              _createElementVNode("td", _hoisted_36, _toDisplayString(dossier.refbesc), 1),
                              _createElementVNode("td", null, _toDisplayString(dossier.client), 1),
                              _createElementVNode("td", null, _toDisplayString(dossier.destination), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", _hoisted_37, _toDisplayString(dossier.transport_type), 1)
                              ]),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  innerHTML: _ctx.getStatusBadge(dossier.status)
                                }, null, 8, _hoisted_38)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(_ctx.format_date(dossier.created_at)), 1),
                              _createElementVNode("td", null, _toDisplayString(_ctx.format_date(dossier.updated_at)), 1),
                              _createElementVNode("td", _hoisted_39, [
                                _createElementVNode("div", _hoisted_40, [
                                  _cache[32] || (_cache[32] = _createElementVNode("span", {
                                    class: "badge text-white bg-primary fs-15 dropdown-toggle",
                                    "data-bs-toggle": "dropdown",
                                    "aria-expanded": "false",
                                    style: {"cursor":"pointer"}
                                  }, [
                                    _createTextVNode(" Actions "),
                                    _createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
                                  ], -1)),
                                  _createElementVNode("ul", _hoisted_41, [
                                    _createElementVNode("li", null, [
                                      _createVNode(_component_router_link, {
                                        to: { name: 'ViewBesc', params: { id: dossier.id } },
                                        class: "dropdown-item d-flex align-items-center"
                                      }, {
                                        default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                          _createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1),
                                          _createTextVNode(" Détails ", -1)
                                        ]))]),
                                        _: 1
                                      }, 8, ["to"])
                                    ]),
                                    (dossier.status === 'BROUILLON')
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_42, [
                                          _createElementVNode("a", {
                                            href: "javascript:void(0);",
                                            onClick: ($event: any) => (_ctx.editDossier(dossier.id)),
                                            class: "dropdown-item d-flex align-items-center"
                                          }, [...(_cache[27] || (_cache[27] = [
                                            _createElementVNode("i", { class: "flaticon-edit lh-1 me-8 position-relative top-1" }, null, -1),
                                            _createTextVNode(" Modifier ", -1)
                                          ]))], 8, _hoisted_43)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (dossier.status === 'BROUILLON')
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_44, [
                                          _createElementVNode("a", {
                                            href: "javascript:void(0);",
                                            onClick: ($event: any) => (_ctx.telechargerBrouillon(dossier.id)),
                                            class: "dropdown-item d-flex align-items-center"
                                          }, [...(_cache[28] || (_cache[28] = [
                                            _createElementVNode("i", { class: "flaticon-file-1 lh-1 me-8 position-relative top-1" }, null, -1),
                                            _createTextVNode(" Télécharger brouillon ", -1)
                                          ]))], 8, _hoisted_45)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (dossier.status === 'VALIDE')
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_46, [
                                          _createElementVNode("a", {
                                            href: "javascript:void(0);",
                                            onClick: ($event: any) => (_ctx.telechargerPDF(dossier.id)),
                                            class: "dropdown-item d-flex align-items-center"
                                          }, [...(_cache[29] || (_cache[29] = [
                                            _createElementVNode("i", { class: "flaticon-file-1 lh-1 me-8 position-relative top-1" }, null, -1),
                                            _createTextVNode(" Télécharger PDF ", -1)
                                          ]))], 8, _hoisted_47)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (_ctx.canDeleteDossier(dossier.status))
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_48, [...(_cache[30] || (_cache[30] = [
                                          _createElementVNode("hr", { class: "dropdown-divider" }, null, -1)
                                        ]))]))
                                      : _createCommentVNode("", true),
                                    (_ctx.canDeleteDossier(dossier.status))
                                      ? (_openBlock(), _createElementBlock("li", _hoisted_49, [
                                          _createElementVNode("a", {
                                            href: "javascript:void(0);",
                                            onClick: ($event: any) => (_ctx.confirmDelete(dossier)),
                                            class: "dropdown-item d-flex align-items-center text-danger"
                                          }, [...(_cache[31] || (_cache[31] = [
                                            _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1),
                                            _createTextVNode(" Supprimer ", -1)
                                          ]))], 8, _hoisted_50)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.totalPages > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, " Affichage " + _toDisplayString((_ctx.currentPage - 1) * _ctx.itemsPerPage + 1) + " à " + _toDisplayString(Math.min(_ctx.currentPage * _ctx.itemsPerPage, _ctx.filteredDossiers.length)) + " sur " + _toDisplayString(_ctx.filteredDossiers.length) + " dossiers ", 1),
                        _createElementVNode("nav", null, [
                          _createElementVNode("ul", _hoisted_53, [
                            _createElementVNode("li", {
                              class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
                            }, [
                              _createElementVNode("button", {
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.currentPage = 1)),
                                class: "page-link"
                              }, "Première")
                            ], 2),
                            _createElementVNode("li", {
                              class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === 1 }])
                            }, [
                              _createElementVNode("button", {
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.currentPage--)),
                                class: "page-link"
                              }, "Précédent")
                            ], 2),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visiblePages, (page) => {
                              return (_openBlock(), _createElementBlock("li", {
                                key: page,
                                class: _normalizeClass(["page-item", { active: page === _ctx.currentPage }])
                              }, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (_ctx.currentPage = page),
                                  class: "page-link"
                                }, _toDisplayString(page), 9, _hoisted_54)
                              ], 2))
                            }), 128)),
                            _createElementVNode("li", {
                              class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
                            }, [
                              _createElementVNode("button", {
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.currentPage++)),
                                class: "page-link"
                              }, "Suivant")
                            ], 2),
                            _createElementVNode("li", {
                              class: _normalizeClass(["page-item", { disabled: _ctx.currentPage === _ctx.totalPages }])
                            }, [
                              _createElementVNode("button", {
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.currentPage = _ctx.totalPages)),
                                class: "page-link"
                              }, "Dernière")
                            ], 2)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
        ])
      ])
    ])
  ]))
}